<template>
  <div>
    <v-toolbar flat :color="entityConfig.header2Color" height="100px">
      <v-container>
        <v-row>
          <v-col cols="6" sm="6" md="6">
            <a @click="$router.push({name: 'Login'})">
              <img
                :src="entityConfig.primaryLogoUrl"
                class="header-brand-img"
                alt="logo"
                width="200px"
              />
            </a>
          </v-col>
          <v-col cols="6" sm="6" md="6">
            <v-btn
              class="float-end"
              style="font-weight: 400; background: #ffffff; letter-spacing: normal;text-transform: none !important;"
              rounded
              depressed
              light
              @click="$router.push({name: 'Login'})"
            >
              {{ $t("MSAUTH01") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-toolbar>
  </div>
</template>

<style scoped lang="scss">
@import "./header-style";
</style>

<script>
export default {
  name: "App",
  data() {
    return {
      entityConfig: {},
      codEntity: '',
    };
  },
  mounted() {
      let timeout = (!window.sessionStorage.getItem('codNrbeEn')) ? 1000 : 100;
      setTimeout(() => {
        this.entityConfig = this.$store.state.entityConfig.config;
        this.codEntity = sessionStorage.getItem('codNrbeEn');
      }, timeout);
  }
};
</script>
